import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormControlTouchStatusPatchModule } from '../form-control-touch-status-patch/form-control-touch-status-patch.module';
import { IconModule } from './../../common/icon/icon.module';
import { TextareaAutosizeDirective } from './textarea-autosize.directive';
import { TextareaComponent } from './textarea.component';

@NgModule({
  declarations: [TextareaComponent, TextareaAutosizeDirective],
  exports: [TextareaComponent, TextareaAutosizeDirective],
  imports: [IconModule, CommonModule, FormControlTouchStatusPatchModule],
})
export class TextareaModule {}

export { TextareaAutosizeDirective } from './textarea-autosize.directive';
export { TextareaComponent } from './textarea.component';
